package ru.it_mozaika.components

import js.core.jso
import mui.material.*
import mui.material.styles.TypographyVariant
import mui.system.responsive
import mui.system.sx
import react.*
import react.dom.aria.AriaRole
import react.dom.aria.ariaLabel
import react.dom.aria.ariaLabelledBy
import react.dom.events.ChangeEvent
import react.dom.html.ReactHTML.div
import ru.it_mozaika.sender.common.models.ColumnsFilter

import tanstack.react.table.renderCell
import tanstack.react.virtual.UseVirtualizerOptions
import tanstack.react.virtual.useVirtualizer
import tanstack.table.core.Table
import web.cssom.*
import web.html.HTMLDivElement
import web.html.HTMLInputElement

external interface CommonTableSkeletonProps: TableContainerProps {
    var onPropertySelect: (String) -> Unit
    var propertiesFilter: List<ColumnsFilter>
    var table: Table<*>
    var dataCount: Int
    var columnId: String
    var label: String
    var onSelectionChanged: (List<String>) -> Unit
    var onDoubleClickHandler: (String) -> Unit
    var toolbarActions: ReactNode?
    var currentSelected: List<String>?
    var showCheckBox: Boolean?
}

val commonTableSkeletonFrame = FC<CommonTableSkeletonProps>{ props ->
    val (selected, setSelected) = useState(listOf<String>()) //Список row id. Отображает список выделенных строк
    val isSelected: (String) -> Boolean = { name ->
         selected.indexOf(name) != -1
    }
    useEffect(selected){
        println("Table skeleton use effect selected - $selected")
        props.onSelectionChanged(selected)
    }
//    useEffect(props.currentSelected){
//        println(" table skeleton use effect props.currentSelected")
////        if (!props.currentSelected.isNullOrEmpty()){
//            setSelected(props.currentSelected!!)
////        }
//    }
    //Проверяет выделена ли строка
//    useEffect(props.currentSelected){
//        setSelected(props.currentSelected ?: listOf())
//    }
//    val rowsModel = useMemo(props.table){}
    val parentRef = useRef<HTMLDivElement>()
    val virtualList = useVirtualizer(
        jso<UseVirtualizerOptions<HTMLDivElement, HTMLDivElement>>{
            this.getScrollElement = useCallback(parentRef.current){parentRef.current}
            this.estimateSize = {5}
            overscan = 30
            this.count = props.table.getRowModel().rows.size
        }
    )
    val handleSelectAllClick: (ChangeEvent<HTMLInputElement>) -> Unit = { event ->
        if (event.target.checked) {
            val newSelected = props.table.getRowModel().rows.map { row ->
                row.getValue(props.columnId).toString()
            }
            setSelected(newSelected)
        } else {
            setSelected(emptyList())
        }
    }

    val handleClick: (String) -> Unit = { name: String ->
        setSelected {
            if (it.contains(name)) {
                it.minus(name)
            } else {
                it.plus(name)
            }
        }
    }
//    useEffect(selected) {
//        props.onSelectionChanged(selected)
//    }
    if(selected.isNotEmpty()){
//        Divider {
//            this.orientation = Orientation.horizontal
//        }
        Grid{
            direction = responsive(GridDirection.row)
//                    asDynamic().justifyContent = "space-between"
            container = true
            sx{
                padding = 5.px
                this.alignItems = AlignItems.center
                justifyContent = JustifyContent.spaceBetween
            }
            Grid{
                item = true
                Stack{
                    direction = responsive(StackDirection.row)
                    spacing = responsive(5.px)
                    sx{
                        padding = 5.px
                        this.alignItems = AlignItems.center
                    }
                    if (props.showCheckBox == true|| props.showCheckBox == null || props.showCheckBox == undefined ) {
                        Checkbox {
                            val rowCount = props.table.getRowModel().rows.size
                            color = CheckboxColor.secondary
                            indeterminate = selected.size > 0 && selected.size < rowCount
                            checked = rowCount > 0 && selected.size == rowCount
                            onChange = { event, checked ->
                                handleSelectAllClick(event)
                                props.onSelectionChanged(selected)
                            }
//                    inputProps = jso<InputHTMLAttributes<HTMLInputElement>>{
//                        ariaLabel = "Выбрать все"
//                    }
                            ariaLabel = "Выбрать все"
                        }
                    }
//                        asDynamic().xs = 4
                    Typography {
                        sx {
//                            asDynamic().flex = "1 1 100%"
                            flexGrow = number(1.0)
                        }
                        +" Выбрано: ${selected.size}"
                        variant = TypographyVariant.h4
                        id = "table-title"
                        component = div
                    }
                }
            }
            Grid{
//                        asDynamic().xs = 8
                item = true
                +props.toolbarActions
            }
        }
        Divider {
            this.orientation = Orientation.horizontal
        }
    }
    TableContainer {
        ref = parentRef
        sx {
            maxHeight = 100.vh - 300.px
        }
        Table {
            ariaLabel = "${props.label}-table"
            ariaLabelledBy = "${props.label}-table-title"
            stickyHeader = true
            if (selected.isEmpty()) {
                tableHead {
                    this.showCheckBox = props.showCheckBox
                    this.table = props.table
                    if (undefined != props.propertiesFilter) {
                        this.propertiesWithFilters = props.propertiesFilter.map { it.columnName }
                    }
                    this.onFilterClick = { propertyId ->
                        props.onPropertySelect(propertyId)
                    }
                    this.numSelected = selected.size
                    this.onSelectAllClick = handleSelectAllClick
                    this.rowCount = table.getRowModel().rows.size

                }
            }
            TableBody {
                virtualList.getVirtualItems().forEach{ item ->
                    val row = props.table.getRowModel().rows[item.index]
                    val cellValue = row.getValue(props.columnId).toString()
                    val isItemSelected = isSelected(cellValue)
                    val labelId = "${props.label}-table-row-${item.index}"
                    TableRow {
                        role = AriaRole.checkbox
                        tabIndex = -1
                        key = cellValue
//                        this.selected = isItemSelected
                        sx {
                            cursor = Cursor.pointer
                        }
                        hover = true
//                                    println("row ${row.}")
                        if (props.showCheckBox == true|| props.showCheckBox == null || props.showCheckBox == undefined ){
                            TableCell {
                                padding = TableCellPadding.checkbox

                                Checkbox {
                                    onClick = {
                                        handleClick(cellValue)
                                        props.onSelectionChanged(selected)
                                    }
                                    color = CheckboxColor.secondary
                                    checked =
                                        isItemSelected
//                                                    .also { println("row${row.getValue("product_id")}: checked = $it") }
                                    inputProps = jso {
                                        ariaLabelledBy = labelId
                                    }
                                }

                            }
                        }
                        row.getVisibleCells().forEachIndexed { index, cell ->
                            TableCell {
//                                component = ReactHTML.td
                                onDoubleClick = {
                                    props.onDoubleClickHandler(cellValue)
                                }
//                                if (index == 0) {
//                                    component = ReactHTML.th
                                    id = labelId
                                    scope = "row"
//                                    padding = TableCellPadding.none
//                                    align = TableCellAlign.center

//                                }
                                +renderCell(cell)
                            }
                        }
                    }
                }
            }
        }
    }
}